module.exports = __webpack_public_path__ + "static/media/1013973.af1689f3.png";